import { Mic, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ManualPTTButtonProps {
  isListening: boolean;
  isProcessing?: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
  disabled?: boolean;
}

export function ManualPTTButton({
  isListening,
  isProcessing = false,
  onStartRecording,
  onStopRecording,
  disabled = false,
}: ManualPTTButtonProps) {
  // Note: Space key handler is now in PTTController for global access

  return (
    <button
      className={cn(
        "fixed bottom-8 left-8 z-50",
        "w-20 h-20 rounded-full shadow-lg",
        "flex items-center justify-center",
        "transition-all duration-200",
        "focus:outline-none focus:ring-4",
        disabled && "opacity-50 cursor-not-allowed",
        isProcessing
          ? "bg-yellow-500 ring-yellow-300"
          : isListening
          ? "bg-red-500 scale-110 animate-pulse ring-red-300"
          : "bg-blue-500 hover:bg-blue-600 ring-blue-300"
      )}
      onClick={(e) => {
        e.preventDefault();
        if (disabled || isProcessing) return;

        // Toggle mode: click to start/stop
        if (isListening) {
          onStopRecording();
        } else {
          onStartRecording();
        }
      }}
      title={
        disabled
          ? "Disabled"
          : isProcessing
          ? "Processing STT..."
          : isListening
          ? "Recording... (Click or Space to stop)"
          : "Click or Space to record"
      }
      disabled={disabled || isProcessing}
    >
      {isProcessing ? (
        <Loader2 className="w-8 h-8 text-white animate-spin" />
      ) : (
        <Mic
          className={cn(
            "w-8 h-8 text-white transition-transform",
            isListening && "scale-125"
          )}
        />
      )}
    </button>
  );
}
